module.exports = __webpack_public_path__ + "static/img/14000471.0bdc5fc1.png";